/**
 * Correlation ID support. On the server uses AsyncLocalStorage; on the client
 * uses a no-op stub (via webpack alias in next.config.js).
 */
export { CORRELATION_HEADER } from './correlation.constants'
export {
  correlationStorage,
  getCorrelationId,
  generateCorrelationId,
  runWithCorrelation
} from './correlation.runtime'
